import { render, staticRenderFns } from "./TeamMoney.vue?vue&type=template&id=7879ca4a&scoped=true"
import script from "./TeamMoney.vue?vue&type=script&lang=js"
export * from "./TeamMoney.vue?vue&type=script&lang=js"
import style0 from "./TeamMoney.vue?vue&type=style&index=0&id=7879ca4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7879ca4a",
  null
  
)

export default component.exports